<div class="p-10 h-full">
    <nz-page-header class="text-[16px] font-semibold p-0 pb-2 m-0" nzTitle="Artículos">
        <nz-page-header-extra class="flex">
            <nz-space class="items-center">
                <input
                    nz-input
                    class="w-[320px]"
                    type="text"
                    placeholder="Buscar por ID, externalId, nombre o EAN"
                    [(ngModel)]="searchText"
                    (ngModelChange)="filterArticles()"
                />
                @if (canCreate()) {
                <button class="button primary-button" (click)="create()">
                    Añadir
                </button>
                }
            </nz-space>
        </nz-page-header-extra>
    </nz-page-header>

    <nz-table #articlesTable nzTableLayout="auto" nzSize="small" [nzData]="filteredArticles" [nzLoading]="isLoading"
        [nzLoadingIndicator]="indicatorTemplate" [nzBordered]="true">
        <thead>
            <tr>
                <th nzWidth="300px">Nombre</th>
                <th nzWidth="300px">EAN</th>
                <th nzWidth="300px">Cantidad</th>
                @if (canRead() || canEdit() || canDelete()) {
                <th nzWidth="200px">Acciones</th>
                }
            </tr>
        </thead>
        <tbody>
            @for (data of articlesTable.data; track data.id) {
            <tr>
                <td>{{ data.name }}</td>
                <td>{{ data.ean }}</td>
                <td>{{ data.quantity }}</td>
                @if (canRead() || canEdit() || canDelete()) {
                <td>
                    <div class="flex align-middle justify-center">
                        @if (canRead()) {
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Ver artículo'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="view(data)">
                            <span nz-icon nzType="eye"></span>
                        </button>
                        @if (canEdit() || canDelete()) {
                        <nz-divider nzType="vertical"></nz-divider>
                        }
                        }

                        @if (canEdit()) {
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Editar artículo'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="edit(data)">
                            <span nz-icon nzType="edit"></span>
                        </button>
                        @if (canDelete()) {
                        <nz-divider nzType="vertical"></nz-divider>
                        }
                        }

                        @if (canDelete()) {
                        <button nz-button nzType="text" nzShape="circle" class="table-icon"
                            [nzTooltipTitle]="'Eliminar artículo'" nzTooltipPlacement="bottom" nz-tooltip
                            (click)="delete(data.id!)">
                            <span nz-icon nzType="delete"></span>
                        </button>
                        }
                    </div>
                </td>
                }
            </tr>
            }
        </tbody>
    </nz-table>
</div>

<ng-template #indicatorTemplate>
    <app-loader></app-loader>
</ng-template>

<nz-drawer [nzClosable]="false" [nzVisible]="drawerVisible" nzPlacement="right" [nzTitle]="title" [nzFooter]="footer"
    (nzOnClose)="closeDrawer()" [nzPlacement]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? 'right':'bottom'"
    [nzWidth]="'90%'" [nzHeight]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? '' : '90%'"
    [nzMaskClosable]="fieldsReadOnly">
    <ng-template #title class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
        <div style="display: flex; align-items: center;">
            <p class="drawer-title"> {{ drawerTitle }} </p>
        </div>
    </ng-template>
    <ng-container *nzDrawerContent>
        <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()" class="h-full">
            <nz-tabset [nzTabPosition]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? 'left' : 'top'" class="h-full">
                <nz-tab nzTitle="Datos">
                    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
                        <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                            <nz-form-label nzRequired>
                                Nombre
                            </nz-form-label>
                            <nz-form-control nzErrorTip="Indique un nombre para el artículo">
                                <input onfocus="select()" nz-input placeholder="Indique un nombre para el artículo" type="text"
                                    id="name" formControlName="name" />
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                            <nz-form-label>
                                Alias
                            </nz-form-label>
                            <nz-form-control nzErrorTip="Indique un alias para el artículo">
                                <input onfocus="select()" nz-input placeholder="Indique un alias para el artículo" type="text"
                                    id="alias" formControlName="alias" />
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                            <nz-form-label nzRequired>
                                EAN
                            </nz-form-label>
                            <nz-form-control nzErrorTip="Indique un EAN para el artículo">
                                <input onfocus="select()" nz-input placeholder="Indique un EAN para el artículo" type="number"
                                    pattern="\d*" id="ean" formControlName="ean" />
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                            <nz-form-label nzRequired>
                                Referencia externa
                            </nz-form-label>
                            <nz-form-control nzErrorTip="Indique una referencia externa para el artículo">
                                <input onfocus="select()" nz-input placeholder="Indique una referencia externa para el artículo"
                                    type="text" id="externalReference" formControlName="externalReference" />
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="8" class="px-4">
                            <nz-form-control>
                                <label nz-checkbox [nzDisabled]="fieldsReadOnly" id="active"
                                    formControlName="active">¿Activado?</label>
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="8" class="px-4">
                            <nz-form-control>
                                <label nz-checkbox [nzDisabled]="fieldsReadOnly || drawerMode !== DrawerMode.CREATE"
                                    id="useBatches" formControlName="useBatches">¿Usa lotes?</label>
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                            <nz-form-label nzRequired>
                                Cantidad
                            </nz-form-label>
                            <nz-form-control nzErrorTip="Indique una cantidad para el artículo">
                                <input onfocus="select()" nz-input placeholder="Indique una cantidad para el artículo"
                                    type="number" pattern="\d*" id="quantity" formControlName="quantity" />
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                            <nz-form-label nzRequired>
                                Unidad de medida
                            </nz-form-label>
                            <nz-form-control nzErrorTip="Seleccione una unidad de medida">
                                <nz-select nzShowSearch nzPlaceHolder="Seleccione una unidad de medida"
                                    [(ngModel)]="measurementUnitSelected" name="measurementUnit" [nzDisabled]="fieldsReadOnly"
                                    [compareWith]="compareById" [ngModelOptions]="{standalone: true}">
                                    @for (m of measurementUnits; track m.id) {
                                    <nz-option [nzLabel]="m.name" [nzValue]="m"></nz-option>
                                    }
                                </nz-select>
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                            <nz-form-label nzRequired>
                                Tipo de artículo
                            </nz-form-label>
                            <nz-form-control nzErrorTip="Seleccione un tipo de artículo">
                                <nz-select nzShowSearch nzPlaceHolder="Seleccione un tipo de artículo"
                                    [(ngModel)]="articleTypeSelected" name="articleType" [nzDisabled]="fieldsReadOnly"
                                    [compareWith]="compareById" [ngModelOptions]="{standalone: true}">
                                    @for (t of articleTypeDto; track t.id) {
                                    <nz-option [nzLabel]="t.name" [nzValue]="t"></nz-option>
                                    }
                                </nz-select>
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item nz-col nzXs="24" nzSm="12" nzMd="12" class="px-4">
                            <nz-form-label>
                                Familias
                            </nz-form-label>
                            <nz-form-control>
                                <nz-select [nzMaxTagCount]="2" [nzMaxTagPlaceholder]="tagPlaceHolder" nzMode="multiple"
                                    nzPlaceHolder="Seleccione una o más familias de artículo"
                                    [(ngModel)]="articleFamiliesSelected" name="familiesSelector" [nzDisabled]="fieldsReadOnly"
                                    [compareWith]="compareArticleFamilies" [ngModelOptions]="{standalone: true}">
                                    @for (f of articleFamilyDto; track f.id) {
                                    <nz-option [nzLabel]="f.name" [nzValue]="f"></nz-option>
                                    }
                                </nz-select>
                                <ng-template #tagPlaceHolder let-selectedList>y {{ selectedList.length }} más
                                    seleccionados</ng-template>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </nz-tab>
                <nz-tab [nzTitle]="'Características ('+(articleSelected.articleFeatureValues ? articleSelected.articleFeatureValues.length : 0)+')'">
                    <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4" [hidden]="fieldsReadOnly">
                        <nz-form-label>
                            Añadir características del artículo
                        </nz-form-label>
                        <nz-form-control>
                            <div class="flex items-center">
                                <div class="flex justify-start items-center" style="width: 85%;">
                                    <nz-select nzShowSearch nzAllowClear [(ngModel)]="articleFeatureSelected" name="articleFeatureSelector" nzPlaceHolder="Selecciona una característica"
                                        [nzDisabled]="fieldsReadOnly" style="width: 50%;" [ngModelOptions]="{standalone: true}">
                                        @for (af of articleFeatures; track af.id) {
                                        <nz-option [nzLabel]="af.feature" [nzValue]="af" [nzDisabled]="isDisabledArticleFeature(af.id!)"></nz-option>
                                        }
                                    </nz-select>
                                    <input onfocus="select()" type="text" nz-input placeholder="Inserte un valor para la característica"
                                    [(ngModel)]="articleFeatureValueAdding.value" name="articleFeatureSelectorInput"
                                    style="width: 50%;" [disabled]="fieldsReadOnly"
                                    id="articleFeatureSelectorInput" [ngModelOptions]="{standalone: true}" />
                                </div>
                                <div class="flex justify-end" style="width: 15%;">
                                    <button nz-button type="button" (click)="addEntryArticleFeature()"
                                        class="button neutral-outlined-button">
                                        <span nz-icon nzType="plus"></span>
                                        Añadir
                                    </button>
                                </div>
                            </div>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-table #articleFeatureValuesTable [nzData]="articleFeatureValuesSelected" class="px-4 pb-4"
                        nzTableLayout="auto" nzSize="small" [nzFrontPagination]="false" [nzShowPagination]="false"
                        [nzBordered]="true">
                        <thead>
                            <tr>
                                <th>Característica</th>
                                <th>Valor</th>
                                @if (!fieldsReadOnly) {
                                <th>Mostrar en características</th>
                                <th>Acciones</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (articleFeatureValue of articleFeatureValuesTable.data; let idx = $index; track idx) {
                            <tr>
                                <td>{{ articleFeatureValue.feature.feature }}</td>
                                <td>{{ articleFeatureValue.value }}</td>
                                @if (!fieldsReadOnly) {
                                <td>
                                    <nz-switch
                                        [(ngModel)]="articleFeatureValue.showOnScreen" name="showOnScreen"
                                        [nzDisabled]="fieldsReadOnly" [ngModelOptions]="{standalone: true}">
                                    </nz-switch>
                                </td>
                                <td class="text-center">
                                    <div class="flex align-middle justify-center">
                                        <button nz-button type="button" nzType="text" nzShape="circle" class="table-icon"
                                            (click)="deleteEntryArticleFeature(articleFeatureValue.frontId!)">
                                            <span nz-icon nzType="delete"></span>
                                        </button>
                                    </div>
                                </td>
                                }
                            </tr>
                            }
                        </tbody>
                    </nz-table>
                </nz-tab>
                <nz-tab [nzTitle]="'Valores de máquina ('+(articleSelected.machineMeasurementsValues ? articleSelected.machineMeasurementsValues.length : 0)+')'">
                    <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4" [hidden]="fieldsReadOnly">
                        <nz-form-label>
                            Añadir valores de máquina
                        </nz-form-label>
                        <nz-form-control>
                            <div class="flex items-center">
                                <div class="flex justify-start items-center" style="width: 85%;">
                                    <nz-select nzShowSearch nzAllowClear [(ngModel)]="machineSelected" name="machineSelector" nzPlaceHolder="Selecciona una máquina"
                                        [nzDisabled]="fieldsReadOnly" style="width: 25%;" [ngModelOptions]="{standalone: true}">
                                        @for (m of machines; track m.id) {
                                        <nz-option [nzLabel]="m.name" [nzValue]="m"></nz-option>
                                        }
                                    </nz-select>
                                    <nz-select nzShowSearch nzAllowClear [(ngModel)]="productionProcessSelected" name="productionProcessSelector" nzPlaceHolder="Selecciona un proceso productivo"
                                        [nzDisabled]="fieldsReadOnly" style="width: 25%;" [ngModelOptions]="{standalone: true}">
                                        @for (pp of productionProcesses; track pp.id) {
                                        <nz-option [nzLabel]="pp.name" [nzValue]="pp"></nz-option>
                                        }
                                    </nz-select>
                                    <nz-select nzShowSearch nzAllowClear [(ngModel)]="machineMeasurementsSelected" name="measurementsSelector" nzPlaceHolder="Selecciona una medida de máquina"
                                        [nzDisabled]="fieldsReadOnly" style="width: 25%;" [ngModelOptions]="{standalone: true}">
                                        @for (mm of machineMeasurements; track mm.id) {
                                        <nz-option [nzLabel]="mm.measurement" [nzValue]="mm"></nz-option>
                                        }
                                    </nz-select>
                                    <input onfocus="select()" type="text" nz-input placeholder="Inserte un valor para la medida"
                                    [(ngModel)]="machineMeasurementsValueAdding.value" name="measurementsSelectorInput"
                                    style="width: 25%;" [disabled]="fieldsReadOnly"
                                    id="measurementsSelectorInput" [ngModelOptions]="{standalone: true}" />
                                </div>
                                <div class="flex justify-end" style="width: 15%;">
                                    <button nz-button type="button" (click)="addEntryMachineMeasurement()"
                                        class="button neutral-outlined-button">
                                        <span nz-icon nzType="plus"></span>
                                        Añadir
                                    </button>
                                </div>
                            </div>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-table #machineMeasurementsTable [nzData]="machineMeasurementsValueSelected" class="px-4 pb-4"
                        nzTableLayout="auto" nzSize="small" [nzFrontPagination]="false" [nzShowPagination]="false"
                        [nzBordered]="true">
                        <thead>
                            <tr>
                                <th>Máquina</th>
                                <th>Proceso productivo</th>
                                <th>Medida de máquina</th>
                                <th>Valor</th>
                                @if (!fieldsReadOnly) {
                                <th>Acciones</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (machineMeasurement of machineMeasurementsTable.data; let idx = $index; track idx) {
                            <tr>
                                <td>{{ machineMeasurement.machine?.name || '-' }}</td>
                                <td>{{ machineMeasurement.productionProcess?.name || 'CUALQUIER PROCESO ASIGNADO A LA MÁQUINA ' + machineMeasurement.machine?.name}}</td>
                                <td>{{ machineMeasurement.machineMeasurement?.measurement }}</td>
                                <td>{{ machineMeasurement.value }}</td>
                                @if (!fieldsReadOnly) {
                                <td class="text-center">
                                    <div class="flex align-middle justify-center">
                                        <button nz-button type="button" nzType="text" nzShape="circle" class="table-icon"
                                            (click)="deleteEntryMachineMeasurement(machineMeasurement.frontId!)">
                                            <span nz-icon nzType="delete"></span>
                                        </button>
                                    </div>
                                </td>
                                }
                            </tr>
                            }
                        </tbody>
                    </nz-table>
                </nz-tab>
                <nz-tab [nzTitle]="'Lotes ('+(articleBatchesSelected ? articleBatchesSelected.length : 0)+')'" [nzDisabled]="drawerMode === DrawerMode.CREATE || !articleSelected.useBatches">
                    <nz-table #articleBatchesTable [nzData]="articleBatchesSelected" class="px-4 pb-4"
                        nzTableLayout="auto" nzSize="small" [nzFrontPagination]="false" [nzShowPagination]="false"
                        [nzBordered]="true">
                        <thead>
                            <tr>
                                <th>Lote</th>
                                <th>Cantidad</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (articleBatch of articleBatchesTable.data; let idx = $index; track idx) {
                            <tr>
                                <td>{{ articleBatch.batchNumber }}</td>
                                <td>{{ articleBatch.quantity}}</td>
                            </tr>
                            }
                        </tbody>
                    </nz-table>
                </nz-tab>
            </nz-tabset>
        </form>
    </ng-container>
    <ng-template #footer>
        <div class="flex justify-end">
            <button class="button secondary-button mr-2" (click)="cancelEditing()">
                Cancelar
            </button>

            @if (!fieldsReadOnly) {
                <button nz-button class="button primary-button" [disabled]="!validateForm.valid" (click)="submitForm()" [nzLoading]="isSaving">
                    Guardar
                </button>
            }
        </div>
    </ng-template>
</nz-drawer>
